import { useGesCloudAnalytics } from "@ext/enterprise-cloud/ui-logic/analytics/GesCloudAnalyticsProvider";
import { useEffect } from "react";

export const TrackGesCloudCatalogOpened = ({ catalogName }: { catalogName: string }) => {
	const analytics = useGesCloudAnalytics();

	useEffect(() => {
		analytics?.track({ name: "catalog_opened", props: { catalog: catalogName } });
	}, [analytics, catalogName]);

	return null;
};
